'use strict';

var _ = require('lodash');
var optWeekReferenceService = function optWeekReferenceService(optWeekService, $q, dataRetrieverService, SearchCriteriaRule, constantsService) {
  function retrieveRomAnalysisReferenceData() {
    var dataRetriever = dataRetrieverService.getDataRetriever(constantsService.ROM_ANALYSIS_SCREEN, constantsService.ROM_ANALYSIS_SKINNY_SERVICES_REFERENCE_MODE);
    var criteria = dataRetriever.getSearchCriteriaRules();
    return criteria.then(function (searchCriteria) {
      var currentOptWeek = optWeekService.getOptWeekData('ROM reference');
      var copiedSearchCriteria = _.cloneDeep(searchCriteria);
      var modifiedSearchCriteria = $q.when(getReferenceOptWeekROMSearchCriteria(currentOptWeek, copiedSearchCriteria));
      dataRetriever.setCustomSearchCriteriaRules(modifiedSearchCriteria);
      dataRetriever.currentSortBy('optGroupWeek').currentSortOrder('DESC');
      return getDataPromise(dataRetriever);
    });
  }
  function retrieveRomSummaryReferenceData() {
    var dataRetriever = dataRetrieverService.getDataRetriever(constantsService.ROM_SUMMARY_SCREEN, constantsService.ROM_SUMMARY_REFERENCE_MODE);
    var criteria = dataRetriever.getSearchCriteriaRules();
    return criteria.then(function (searchCriteria) {
      var refOptWeekData = optWeekService.getOptWeekData('ROM reference');
      var copiedSearchCriteria = _.cloneDeep(searchCriteria);
      var modifiedSearchCriteria = $q.when(getReferenceOptWeekROMSearchCriteria(refOptWeekData, copiedSearchCriteria));
      dataRetriever.setCustomSearchCriteriaRules(modifiedSearchCriteria);
      return getDataPromise(dataRetriever);
    });
  }
  function getDataPromise(dataRetriever) {
    return dataRetriever.localSortApplied().retrieveComponentData('kpi-ribbon-reference');
  }
  function getReferenceOptWeekROMSearchCriteria(refOptWeekData, searchCriteria) {
    var optWeekCriteria = _.filter(searchCriteria, optGroupWeekPredicate);
    if (optWeekCriteria.length === 1 && optWeekCriteria[0].operator === '=') {
      var optWeekCriteriaValues = _.map(optWeekCriteria[0].leftOperand, getLeftOperandValue);
      var refOptWeekDataValues = _.map(refOptWeekData, 'value');
      if (_.isEqual(optWeekCriteriaValues, refOptWeekDataValues)) {
        return searchCriteria;
      }
    }
    return replaceOptWeekCriteria(searchCriteria, refOptWeekData);
  }
  function getLeftOperandValue(leftOperand) {
    return leftOperand.value ? leftOperand.value : leftOperand;
  }
  function replaceOptWeekCriteria(criteria, refOptWeekData) {
    var newCriteria = _.filter(criteria, _.negate(optGroupWeekPredicate));
    var newOptWeekCriteria = new SearchCriteriaRule({
      field: 'custom:strictDateComparison:optGroupWeek',
      operator: '=',
      leftOperand: refOptWeekData
    });
    newCriteria.unshift(newOptWeekCriteria);
    return newCriteria;
  }
  function optGroupWeekPredicate(rule) {
    return rule.field.indexOf('optGroupWeek') > -1;
  }
  return {
    retrieveRomAnalysisReferenceData: retrieveRomAnalysisReferenceData,
    retrieveRomSummaryReferenceData: retrieveRomSummaryReferenceData,
    startRetrievingOptWeekRefForRomAnalysisScreen: retrieveRomAnalysisReferenceData,
    startRetrievingOptWeekRefForRomSummaryScreen: retrieveRomSummaryReferenceData
  };
};
optWeekReferenceService.$inject = ['OptWeekService', '$q', 'DataRetrieverService', 'SearchCriteriaRuleFactory', 'DataRetrieverConstantsService'];
module.exports = optWeekReferenceService;